import { EventInterface } from "./event.interface";

export interface EventButtons {
    createEventButton: string;
    editEventButton: string;
    createPostEventButton: string;
    editPostEventButton: string;
    getReportButton: string;
    getPostEventReportButton: string;
    continueButton: string;
    deleteEventButton: string;
  }

  export interface EventsResponse {
    events: EventInterface[];
    buttons: EventButtons;
    page: number;
    totalPages: number;
  }

  export const defaultButtons: EventButtons = {
    createEventButton: 'Create event',
    editEventButton: 'Edit event',
    createPostEventButton: 'Create post event',
    editPostEventButton: 'Edit post event',
    getReportButton: 'Get report',
    getPostEventReportButton: 'Get post event report',
    continueButton: 'Continue',
    deleteEventButton: 'Delete event'
  };
